import CRUDService from 'src/services/CRUDService';
import {EducationPhase} from '../types/enums';

export interface ScheduledReport {
  name: string;
  studentSearchType: EducationPhase;
  _id: string;
  filename: string;
  newFollowersOnly: boolean;
  active?: boolean;
}

export default new CRUDService<ScheduledReport>({
  baseUrl: '/v1/lists/scheduled-reports',
});
